export const componentData = window.COMPONENT_DATA || {};
